import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport matches the given media query.
 * Uses matchMedia so it responds to real breakpoints, not resize events.
 * Default breakpoint matches the `sm` boundary used throughout the CSS (640px).
 */
export function useIsMobile(query = '(max-width: 639px)'): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
